import { defineNuxtPlugin } from '#app/nuxt'
import { LazyTwAccountAdsAndSearchHousingCard, LazyTwAccountAdsAndSearchHousingCardActivationBadge, LazyTwAccountAdsAndSearchHousingCardImage, LazyTwAccountAdsAndSearchHousingCardInfo, LazyTwAccountAdsAndSearchStatistics, LazyTwAccountAlertWeakCredentials, LazyTwAccountNavigation, LazyTwAccountSettingsButtonSubmit, LazyTwAccountSettingsButtonText, LazyTwAccountSettingsLayout, LazyTwAccountSettingsModalCancelSubscription, LazyTwAccountSettingsModalDeactivate, LazyTwAccountSettingsModalDeleteAccount, LazyTwAccountSettingsNavigation, LazyTwAccountSettingsOption, LazyTwAccountSettingsProfileImageUpload, LazyTwBackView, LazyTwBannerRingSwapHint, LazyTwBannerWeakPassword, LazyTwButton, LazyTwButtonRegister, LazyTwButtonWatchList, LazyTwChatHeader, LazyTwChatRoomListFilter, LazyTwChatRoomListFilterSearch, LazyTwChatRoomListFilterStatus, LazyTwChatRoomList, LazyTwChatRoomListItem, LazyTwChatRoomListSkeleton, LazyTwChatRoomAvatarNamesDisplay, LazyTwChatRoomFirstContact, LazyTwChatRoomHeader, LazyTwChatRoomLimitation, LazyTwChatRoomMessageBubbleTemp, LazyTwChatRoomMessageBubble, LazyTwChatRoomNewMessageForm, LazyTwChatRoomView, LazyTwCircledNumber, LazyTwCompanyInfo, LazyTwDynamicContent, LazyTwError404, LazyTwError500, LazyTwExportModal, LazyTwExportStatusModal, LazyTwFaq, LazyTwFilterAllFiltersModal, LazyTwFilterAllFiltersTabs, LazyTwFilterBarMobile, LazyTwFilterBar, LazyTwFilterDropdownSelectStorey, LazyTwFilterEnergyEfficiencyCheckboxList, LazyTwFilterHousingPropertiesBadgeList, LazyTwFilterHousingPropertiesCheckboxList, LazyTwFilterHousingTypeCheckboxList, LazyTwFilterLanguagesCheckboxList, LazyTwFilterLocationsBadgeList, LazyTwFilterLocationsCheckboxList, LazyTwFilterLocationsRadioList, LazyTwFilterLocationsSearch, LazyTwFilterNumberMaxInput, LazyTwFilterNumberMinInput, LazyTwFilterRadiusCheckboxList, LazyTwFilterRadiusInput, LazyTwFilterRadiusSlider, LazyTwFilterRentMaxInput, LazyTwFilterRoomsMinCheckboxList, LazyTwFilterSizeMinInput, LazyTwFilterSmokingCheckboxList, LazyTwFilterWgTypeCheckboxList, LazyTwFormError, LazyTwFormInputCheckbox, LazyTwFormInputEmail, LazyTwFormInputPassword, LazyTwFormInputRadio, LazyTwFormInputSwitch, LazyTwFormInputText, LazyTwFormLogin, LazyTwFormMultiselect, LazyTwFormSelectEnergyEfficiencyClass, LazyTwFormSelectGeoId, LazyTwFormSelectHousingProperties, LazyTwFormSelectHousingType, LazyTwFormSelectSharedFlatLanguages, LazyTwFormSelectSharedFlatType, LazyTwFormSelectSmokingProperty, LazyTwHousingCardList, LazyTwHousingCard, LazyTwHousingCardFooter, LazyTwHousingCardHousingInfo, LazyTwHousingArticle, LazyTwHousingBtnActivate, LazyTwHousingBtnContact, LazyTwHousingBtnEdit, LazyTwHousingBtnLike, LazyTwHousingBtnPdfDownload, LazyTwHousingBtnReport, LazyTwHousingBtnShare, LazyTwHousingBtnUnlike, LazyTwHousingCarousel, LazyTwHousingEditModal, LazyTwHousingEditModalDescription, LazyTwHousingEditModalFeatures, LazyTwHousingEditModalInfo, LazyTwHousingFeatures, LazyTwHousingInfoCard, LazyTwHousingInfo, LazyTwHousingMapHidden, LazyTwHousingMap, LazyTwHousingNotFound, LazyTwHousingPrimaryHeading, LazyTwHousingSearching, LazyTwHousingSecondaryHeading, LazyTwHousingSimilar, LazyTwHousingSummary, LazyTwIconLogo, LazyTwIconRtPeople, LazyTwIconRtTradeVariant, LazyTwImageUploadImagesUpload, LazyTwLayoutPageFooterReferences, LazyTwLayoutPageFooter, LazyTwLayoutPageHeaderRegistration, LazyTwLayoutPageHeader, LazyTwLayoutPageLogoRegistration, LazyTwLayoutPageMobileNavigation, LazyTwLayoutPageNavigationItem, LazyTwLayoutPageNavigationSubmenu, LazyTwLayoutPageNavigationToggle, LazyTwLayoutPageNavigation, LazyTwLayoutScrollToTop, LazyTwLightBox, LazyTwLinkCookieConsent, LazyTwLinkSupportForm, LazyTwLoading, LazyTwLoginAlertEmailNotConfirmed, LazyTwLoginAlertWeakCredentials, LazyTwLoginAlertWrongCredentials, LazyTwMessageUpdateHousingForUpsell, LazyTwModalConversion, LazyTwMultiPortalPartner, LazyTwMultiPortalProductRadioInput, LazyTwMultiPortalPurchaseConditionsNotMetView, LazyTwMultiPortalPurchaseFaq, LazyTwMultiPortalPurchaseView, LazyTwMultiPortalPurchasedView, LazyTwMultiPortalTypePayment, LazyTwNavFurtherAction, LazyTwNavItem, LazyTwNavItemIcon, LazyTwNavItemLabel, LazyTwNavItemLink, LazyTwNavLinkCard, LazyTwNavUnauthenticated, LazyTwOfferErrorNotFound, LazyTwOfferGuest, LazyTwOffer, LazyTwOfferInfo, LazyTwOfferListIntermediateMatches, LazyTwOfferListItem, LazyTwOfferMatch, LazyTwOfferMatchDirect, LazyTwOfferMatchInfographicDirect, LazyTwOfferMatchInfographicRing, LazyTwOfferMatchMismatchItem, LazyTwOfferMatchNomatch, LazyTwOfferMatchPartnerBox, LazyTwOfferMatchPartnerBoxBodySearch, LazyTwOfferMatchPartnerBoxBody, LazyTwOfferMatchPartnerBoxFooterBadParams, LazyTwOfferMatchPartnerBoxFooter, LazyTwOfferMatchPartnerBoxHeader, LazyTwOfferMatchPartnerInterest, LazyTwOfferMatchRing, LazyTwOfferMatchRingExchangeOptions, LazyTwOfferMatchRingPagination, LazyTwOfferMatchType, LazyTwOfferOwn, LazyTwOfferSwapDetails, LazyTwPagesAdvancedNavigation, LazyTwPagesOfferSwapDetails, LazyTwPagesOffer, LazyTwPagesRingSwapAllChats, LazyTwPagesRingSwapContact, LazyTwPagesSearch, LazyTwPremiumTeaserWidget, LazyTwProfileCompletion, LazyTwRegistrationAdditionalHomeDetails, LazyTwRegistrationAlertWeakCredentials, LazyTwRegistrationHomeData, LazyTwRegistration, LazyTwRegistrationInfo, LazyTwRegistrationSuccess, LazyTwRegistrationSearchData, LazyTwReportHousingCardModal, LazyTwRingSwapContactModal, LazyTwRtAllChatsHeader, LazyTwRtAllChatsItem, LazyTwRtContactHeader, LazyTwRtContactHousingCard, LazyTwRtInterestBox, LazyTwSearchCardList, LazyTwSearchCard, LazyTwSearchCardSearchInfo, LazyTwSearchInfoWidget, LazyTwSearchAllFiltersModal, LazyTwSearchBarMobile, LazyTwSearchBar, LazyTwShareAdModal, LazyTwShoutOutsActivateSubscription, LazyTwShoutOutsAdjustSearchFilter, LazyTwShoutOutsDiscountOrSubscription, LazyTwShoutOutsDiscount, LazyTwShoutOutsHousingRingSwapDefault, LazyTwShoutOutsHousingRingSwapFaq, LazyTwShoutOutsHousingRingSwapInfo, LazyTwShoutOutsHousingRingSwapPotentialPartner3, LazyTwShoutOuts, LazyTwShoutOutsMultiPortalModal, LazyTwShoutOutsMultiPortal, LazyTwShoutOutsRegisterNow, LazyTwShoutOutsRegistrationConversion, LazyTwShoutOutsSuccessStory, LazyTwShowMore, LazyTwSkeleton, LazyTwSsoButtons, LazyTwTradeVariantBadge, LazyTwTrustpilotWidget, LazyTwTypography, LazyTwUiAccordionItem, LazyTwUiAccordion, LazyTwUiAction, LazyTwUiActivateSubscription, LazyTwUiBadge, LazyTwUiButton, LazyTwUiCarouselConversionOverlay, LazyTwUiCarousel, LazyTwUiCheckbox, LazyTwUiDivider, LazyTwUiDonutProgress, LazyTwUiDropdownTrigger, LazyTwUiDropdown, LazyTwUiFilterButtons, LazyTwUiFirstContactBadge, LazyTwUiIncreaseResponseRate, LazyTwUiInputNumber, LazyTwUiInputString, LazyTwUiInterestThumbButtons, LazyTwUiMenu, LazyTwUiMessageBox, LazyTwUiModalTrigger, LazyTwUiModal, LazyTwUiNavigationSecondary, LazyTwUiNotification, LazyTwUiOrderByModal, LazyTwUiOrderBy, LazyTwUiOrderDropdown, LazyTwUiOrderModal, LazyTwUiPagination, LazyTwUiPeopleStatus, LazyTwUiProgress, LazyTwUiSelectOffersDesktopSidebar, LazyTwUiSelectTradeVariantsDesktopSidebar, LazyTwUiSelect, LazyTwUiShowOnlyModal, LazyTwUiShowOnly, LazyTwUiSlider, LazyTwUiSpinner, LazyTwUiTabBar, LazyTwUiToast, LazyTwUiTooltip, LazyTwUiTopBar, LazyTwUiTradeVariants, LazyTwUiUserInfo, LazyTwUserAvatar, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["TwAccountAdsAndSearchHousingCard", LazyTwAccountAdsAndSearchHousingCard],
["TwAccountAdsAndSearchHousingCardActivationBadge", LazyTwAccountAdsAndSearchHousingCardActivationBadge],
["TwAccountAdsAndSearchHousingCardImage", LazyTwAccountAdsAndSearchHousingCardImage],
["TwAccountAdsAndSearchHousingCardInfo", LazyTwAccountAdsAndSearchHousingCardInfo],
["TwAccountAdsAndSearchStatistics", LazyTwAccountAdsAndSearchStatistics],
["TwAccountAlertWeakCredentials", LazyTwAccountAlertWeakCredentials],
["TwAccountNavigation", LazyTwAccountNavigation],
["TwAccountSettingsButtonSubmit", LazyTwAccountSettingsButtonSubmit],
["TwAccountSettingsButtonText", LazyTwAccountSettingsButtonText],
["TwAccountSettingsLayout", LazyTwAccountSettingsLayout],
["TwAccountSettingsModalCancelSubscription", LazyTwAccountSettingsModalCancelSubscription],
["TwAccountSettingsModalDeactivate", LazyTwAccountSettingsModalDeactivate],
["TwAccountSettingsModalDeleteAccount", LazyTwAccountSettingsModalDeleteAccount],
["TwAccountSettingsNavigation", LazyTwAccountSettingsNavigation],
["TwAccountSettingsOption", LazyTwAccountSettingsOption],
["TwAccountSettingsProfileImageUpload", LazyTwAccountSettingsProfileImageUpload],
["TwBackView", LazyTwBackView],
["TwBannerRingSwapHint", LazyTwBannerRingSwapHint],
["TwBannerWeakPassword", LazyTwBannerWeakPassword],
["TwButton", LazyTwButton],
["TwButtonRegister", LazyTwButtonRegister],
["TwButtonWatchList", LazyTwButtonWatchList],
["TwChatHeader", LazyTwChatHeader],
["TwChatRoomListFilter", LazyTwChatRoomListFilter],
["TwChatRoomListFilterSearch", LazyTwChatRoomListFilterSearch],
["TwChatRoomListFilterStatus", LazyTwChatRoomListFilterStatus],
["TwChatRoomList", LazyTwChatRoomList],
["TwChatRoomListItem", LazyTwChatRoomListItem],
["TwChatRoomListSkeleton", LazyTwChatRoomListSkeleton],
["TwChatRoomAvatarNamesDisplay", LazyTwChatRoomAvatarNamesDisplay],
["TwChatRoomFirstContact", LazyTwChatRoomFirstContact],
["TwChatRoomHeader", LazyTwChatRoomHeader],
["TwChatRoomLimitation", LazyTwChatRoomLimitation],
["TwChatRoomMessageBubbleTemp", LazyTwChatRoomMessageBubbleTemp],
["TwChatRoomMessageBubble", LazyTwChatRoomMessageBubble],
["TwChatRoomNewMessageForm", LazyTwChatRoomNewMessageForm],
["TwChatRoomView", LazyTwChatRoomView],
["TwCircledNumber", LazyTwCircledNumber],
["TwCompanyInfo", LazyTwCompanyInfo],
["TwDynamicContent", LazyTwDynamicContent],
["TwError404", LazyTwError404],
["TwError500", LazyTwError500],
["TwExportModal", LazyTwExportModal],
["TwExportStatusModal", LazyTwExportStatusModal],
["TwFaq", LazyTwFaq],
["TwFilterAllFiltersModal", LazyTwFilterAllFiltersModal],
["TwFilterAllFiltersTabs", LazyTwFilterAllFiltersTabs],
["TwFilterBarMobile", LazyTwFilterBarMobile],
["TwFilterBar", LazyTwFilterBar],
["TwFilterDropdownSelectStorey", LazyTwFilterDropdownSelectStorey],
["TwFilterEnergyEfficiencyCheckboxList", LazyTwFilterEnergyEfficiencyCheckboxList],
["TwFilterHousingPropertiesBadgeList", LazyTwFilterHousingPropertiesBadgeList],
["TwFilterHousingPropertiesCheckboxList", LazyTwFilterHousingPropertiesCheckboxList],
["TwFilterHousingTypeCheckboxList", LazyTwFilterHousingTypeCheckboxList],
["TwFilterLanguagesCheckboxList", LazyTwFilterLanguagesCheckboxList],
["TwFilterLocationsBadgeList", LazyTwFilterLocationsBadgeList],
["TwFilterLocationsCheckboxList", LazyTwFilterLocationsCheckboxList],
["TwFilterLocationsRadioList", LazyTwFilterLocationsRadioList],
["TwFilterLocationsSearch", LazyTwFilterLocationsSearch],
["TwFilterNumberMaxInput", LazyTwFilterNumberMaxInput],
["TwFilterNumberMinInput", LazyTwFilterNumberMinInput],
["TwFilterRadiusCheckboxList", LazyTwFilterRadiusCheckboxList],
["TwFilterRadiusInput", LazyTwFilterRadiusInput],
["TwFilterRadiusSlider", LazyTwFilterRadiusSlider],
["TwFilterRentMaxInput", LazyTwFilterRentMaxInput],
["TwFilterRoomsMinCheckboxList", LazyTwFilterRoomsMinCheckboxList],
["TwFilterSizeMinInput", LazyTwFilterSizeMinInput],
["TwFilterSmokingCheckboxList", LazyTwFilterSmokingCheckboxList],
["TwFilterWgTypeCheckboxList", LazyTwFilterWgTypeCheckboxList],
["TwFormError", LazyTwFormError],
["TwFormInputCheckbox", LazyTwFormInputCheckbox],
["TwFormInputEmail", LazyTwFormInputEmail],
["TwFormInputPassword", LazyTwFormInputPassword],
["TwFormInputRadio", LazyTwFormInputRadio],
["TwFormInputSwitch", LazyTwFormInputSwitch],
["TwFormInputText", LazyTwFormInputText],
["TwFormLogin", LazyTwFormLogin],
["TwFormMultiselect", LazyTwFormMultiselect],
["TwFormSelectEnergyEfficiencyClass", LazyTwFormSelectEnergyEfficiencyClass],
["TwFormSelectGeoId", LazyTwFormSelectGeoId],
["TwFormSelectHousingProperties", LazyTwFormSelectHousingProperties],
["TwFormSelectHousingType", LazyTwFormSelectHousingType],
["TwFormSelectSharedFlatLanguages", LazyTwFormSelectSharedFlatLanguages],
["TwFormSelectSharedFlatType", LazyTwFormSelectSharedFlatType],
["TwFormSelectSmokingProperty", LazyTwFormSelectSmokingProperty],
["TwHousingCardList", LazyTwHousingCardList],
["TwHousingCard", LazyTwHousingCard],
["TwHousingCardFooter", LazyTwHousingCardFooter],
["TwHousingCardHousingInfo", LazyTwHousingCardHousingInfo],
["TwHousingArticle", LazyTwHousingArticle],
["TwHousingBtnActivate", LazyTwHousingBtnActivate],
["TwHousingBtnContact", LazyTwHousingBtnContact],
["TwHousingBtnEdit", LazyTwHousingBtnEdit],
["TwHousingBtnLike", LazyTwHousingBtnLike],
["TwHousingBtnPdfDownload", LazyTwHousingBtnPdfDownload],
["TwHousingBtnReport", LazyTwHousingBtnReport],
["TwHousingBtnShare", LazyTwHousingBtnShare],
["TwHousingBtnUnlike", LazyTwHousingBtnUnlike],
["TwHousingCarousel", LazyTwHousingCarousel],
["TwHousingEditModal", LazyTwHousingEditModal],
["TwHousingEditModalDescription", LazyTwHousingEditModalDescription],
["TwHousingEditModalFeatures", LazyTwHousingEditModalFeatures],
["TwHousingEditModalInfo", LazyTwHousingEditModalInfo],
["TwHousingFeatures", LazyTwHousingFeatures],
["TwHousingInfoCard", LazyTwHousingInfoCard],
["TwHousingInfo", LazyTwHousingInfo],
["TwHousingMapHidden", LazyTwHousingMapHidden],
["TwHousingMap", LazyTwHousingMap],
["TwHousingNotFound", LazyTwHousingNotFound],
["TwHousingPrimaryHeading", LazyTwHousingPrimaryHeading],
["TwHousingSearching", LazyTwHousingSearching],
["TwHousingSecondaryHeading", LazyTwHousingSecondaryHeading],
["TwHousingSimilar", LazyTwHousingSimilar],
["TwHousingSummary", LazyTwHousingSummary],
["TwIconLogo", LazyTwIconLogo],
["TwIconRtPeople", LazyTwIconRtPeople],
["TwIconRtTradeVariant", LazyTwIconRtTradeVariant],
["TwImageUploadImagesUpload", LazyTwImageUploadImagesUpload],
["TwLayoutPageFooterReferences", LazyTwLayoutPageFooterReferences],
["TwLayoutPageFooter", LazyTwLayoutPageFooter],
["TwLayoutPageHeaderRegistration", LazyTwLayoutPageHeaderRegistration],
["TwLayoutPageHeader", LazyTwLayoutPageHeader],
["TwLayoutPageLogoRegistration", LazyTwLayoutPageLogoRegistration],
["TwLayoutPageMobileNavigation", LazyTwLayoutPageMobileNavigation],
["TwLayoutPageNavigationItem", LazyTwLayoutPageNavigationItem],
["TwLayoutPageNavigationSubmenu", LazyTwLayoutPageNavigationSubmenu],
["TwLayoutPageNavigationToggle", LazyTwLayoutPageNavigationToggle],
["TwLayoutPageNavigation", LazyTwLayoutPageNavigation],
["TwLayoutScrollToTop", LazyTwLayoutScrollToTop],
["TwLightBox", LazyTwLightBox],
["TwLinkCookieConsent", LazyTwLinkCookieConsent],
["TwLinkSupportForm", LazyTwLinkSupportForm],
["TwLoading", LazyTwLoading],
["TwLoginAlertEmailNotConfirmed", LazyTwLoginAlertEmailNotConfirmed],
["TwLoginAlertWeakCredentials", LazyTwLoginAlertWeakCredentials],
["TwLoginAlertWrongCredentials", LazyTwLoginAlertWrongCredentials],
["TwMessageUpdateHousingForUpsell", LazyTwMessageUpdateHousingForUpsell],
["TwModalConversion", LazyTwModalConversion],
["TwMultiPortalPartner", LazyTwMultiPortalPartner],
["TwMultiPortalProductRadioInput", LazyTwMultiPortalProductRadioInput],
["TwMultiPortalPurchaseConditionsNotMetView", LazyTwMultiPortalPurchaseConditionsNotMetView],
["TwMultiPortalPurchaseFaq", LazyTwMultiPortalPurchaseFaq],
["TwMultiPortalPurchaseView", LazyTwMultiPortalPurchaseView],
["TwMultiPortalPurchasedView", LazyTwMultiPortalPurchasedView],
["TwMultiPortalTypePayment", LazyTwMultiPortalTypePayment],
["TwNavFurtherAction", LazyTwNavFurtherAction],
["TwNavItem", LazyTwNavItem],
["TwNavItemIcon", LazyTwNavItemIcon],
["TwNavItemLabel", LazyTwNavItemLabel],
["TwNavItemLink", LazyTwNavItemLink],
["TwNavLinkCard", LazyTwNavLinkCard],
["TwNavUnauthenticated", LazyTwNavUnauthenticated],
["TwOfferErrorNotFound", LazyTwOfferErrorNotFound],
["TwOfferGuest", LazyTwOfferGuest],
["TwOffer", LazyTwOffer],
["TwOfferInfo", LazyTwOfferInfo],
["TwOfferListIntermediateMatches", LazyTwOfferListIntermediateMatches],
["TwOfferListItem", LazyTwOfferListItem],
["TwOfferMatch", LazyTwOfferMatch],
["TwOfferMatchDirect", LazyTwOfferMatchDirect],
["TwOfferMatchInfographicDirect", LazyTwOfferMatchInfographicDirect],
["TwOfferMatchInfographicRing", LazyTwOfferMatchInfographicRing],
["TwOfferMatchMismatchItem", LazyTwOfferMatchMismatchItem],
["TwOfferMatchNomatch", LazyTwOfferMatchNomatch],
["TwOfferMatchPartnerBox", LazyTwOfferMatchPartnerBox],
["TwOfferMatchPartnerBoxBodySearch", LazyTwOfferMatchPartnerBoxBodySearch],
["TwOfferMatchPartnerBoxBody", LazyTwOfferMatchPartnerBoxBody],
["TwOfferMatchPartnerBoxFooterBadParams", LazyTwOfferMatchPartnerBoxFooterBadParams],
["TwOfferMatchPartnerBoxFooter", LazyTwOfferMatchPartnerBoxFooter],
["TwOfferMatchPartnerBoxHeader", LazyTwOfferMatchPartnerBoxHeader],
["TwOfferMatchPartnerInterest", LazyTwOfferMatchPartnerInterest],
["TwOfferMatchRing", LazyTwOfferMatchRing],
["TwOfferMatchRingExchangeOptions", LazyTwOfferMatchRingExchangeOptions],
["TwOfferMatchRingPagination", LazyTwOfferMatchRingPagination],
["TwOfferMatchType", LazyTwOfferMatchType],
["TwOfferOwn", LazyTwOfferOwn],
["TwOfferSwapDetails", LazyTwOfferSwapDetails],
["TwPagesAdvancedNavigation", LazyTwPagesAdvancedNavigation],
["TwPagesOfferSwapDetails", LazyTwPagesOfferSwapDetails],
["TwPagesOffer", LazyTwPagesOffer],
["TwPagesRingSwapAllChats", LazyTwPagesRingSwapAllChats],
["TwPagesRingSwapContact", LazyTwPagesRingSwapContact],
["TwPagesSearch", LazyTwPagesSearch],
["TwPremiumTeaserWidget", LazyTwPremiumTeaserWidget],
["TwProfileCompletion", LazyTwProfileCompletion],
["TwRegistrationAdditionalHomeDetails", LazyTwRegistrationAdditionalHomeDetails],
["TwRegistrationAlertWeakCredentials", LazyTwRegistrationAlertWeakCredentials],
["TwRegistrationHomeData", LazyTwRegistrationHomeData],
["TwRegistration", LazyTwRegistration],
["TwRegistrationInfo", LazyTwRegistrationInfo],
["TwRegistrationSuccess", LazyTwRegistrationSuccess],
["TwRegistrationSearchData", LazyTwRegistrationSearchData],
["TwReportHousingCardModal", LazyTwReportHousingCardModal],
["TwRingSwapContactModal", LazyTwRingSwapContactModal],
["TwRtAllChatsHeader", LazyTwRtAllChatsHeader],
["TwRtAllChatsItem", LazyTwRtAllChatsItem],
["TwRtContactHeader", LazyTwRtContactHeader],
["TwRtContactHousingCard", LazyTwRtContactHousingCard],
["TwRtInterestBox", LazyTwRtInterestBox],
["TwSearchCardList", LazyTwSearchCardList],
["TwSearchCard", LazyTwSearchCard],
["TwSearchCardSearchInfo", LazyTwSearchCardSearchInfo],
["TwSearchInfoWidget", LazyTwSearchInfoWidget],
["TwSearchAllFiltersModal", LazyTwSearchAllFiltersModal],
["TwSearchBarMobile", LazyTwSearchBarMobile],
["TwSearchBar", LazyTwSearchBar],
["TwShareAdModal", LazyTwShareAdModal],
["TwShoutOutsActivateSubscription", LazyTwShoutOutsActivateSubscription],
["TwShoutOutsAdjustSearchFilter", LazyTwShoutOutsAdjustSearchFilter],
["TwShoutOutsDiscountOrSubscription", LazyTwShoutOutsDiscountOrSubscription],
["TwShoutOutsDiscount", LazyTwShoutOutsDiscount],
["TwShoutOutsHousingRingSwapDefault", LazyTwShoutOutsHousingRingSwapDefault],
["TwShoutOutsHousingRingSwapFaq", LazyTwShoutOutsHousingRingSwapFaq],
["TwShoutOutsHousingRingSwapInfo", LazyTwShoutOutsHousingRingSwapInfo],
["TwShoutOutsHousingRingSwapPotentialPartner3", LazyTwShoutOutsHousingRingSwapPotentialPartner3],
["TwShoutOuts", LazyTwShoutOuts],
["TwShoutOutsMultiPortalModal", LazyTwShoutOutsMultiPortalModal],
["TwShoutOutsMultiPortal", LazyTwShoutOutsMultiPortal],
["TwShoutOutsRegisterNow", LazyTwShoutOutsRegisterNow],
["TwShoutOutsRegistrationConversion", LazyTwShoutOutsRegistrationConversion],
["TwShoutOutsSuccessStory", LazyTwShoutOutsSuccessStory],
["TwShowMore", LazyTwShowMore],
["TwSkeleton", LazyTwSkeleton],
["TwSsoButtons", LazyTwSsoButtons],
["TwTradeVariantBadge", LazyTwTradeVariantBadge],
["TwTrustpilotWidget", LazyTwTrustpilotWidget],
["TwTypography", LazyTwTypography],
["TwUiAccordionItem", LazyTwUiAccordionItem],
["TwUiAccordion", LazyTwUiAccordion],
["TwUiAction", LazyTwUiAction],
["TwUiActivateSubscription", LazyTwUiActivateSubscription],
["TwUiBadge", LazyTwUiBadge],
["TwUiButton", LazyTwUiButton],
["TwUiCarouselConversionOverlay", LazyTwUiCarouselConversionOverlay],
["TwUiCarousel", LazyTwUiCarousel],
["TwUiCheckbox", LazyTwUiCheckbox],
["TwUiDivider", LazyTwUiDivider],
["TwUiDonutProgress", LazyTwUiDonutProgress],
["TwUiDropdownTrigger", LazyTwUiDropdownTrigger],
["TwUiDropdown", LazyTwUiDropdown],
["TwUiFilterButtons", LazyTwUiFilterButtons],
["TwUiFirstContactBadge", LazyTwUiFirstContactBadge],
["TwUiIncreaseResponseRate", LazyTwUiIncreaseResponseRate],
["TwUiInputNumber", LazyTwUiInputNumber],
["TwUiInputString", LazyTwUiInputString],
["TwUiInterestThumbButtons", LazyTwUiInterestThumbButtons],
["TwUiMenu", LazyTwUiMenu],
["TwUiMessageBox", LazyTwUiMessageBox],
["TwUiModalTrigger", LazyTwUiModalTrigger],
["TwUiModal", LazyTwUiModal],
["TwUiNavigationSecondary", LazyTwUiNavigationSecondary],
["TwUiNotification", LazyTwUiNotification],
["TwUiOrderByModal", LazyTwUiOrderByModal],
["TwUiOrderBy", LazyTwUiOrderBy],
["TwUiOrderDropdown", LazyTwUiOrderDropdown],
["TwUiOrderModal", LazyTwUiOrderModal],
["TwUiPagination", LazyTwUiPagination],
["TwUiPeopleStatus", LazyTwUiPeopleStatus],
["TwUiProgress", LazyTwUiProgress],
["TwUiSelectOffersDesktopSidebar", LazyTwUiSelectOffersDesktopSidebar],
["TwUiSelectTradeVariantsDesktopSidebar", LazyTwUiSelectTradeVariantsDesktopSidebar],
["TwUiSelect", LazyTwUiSelect],
["TwUiShowOnlyModal", LazyTwUiShowOnlyModal],
["TwUiShowOnly", LazyTwUiShowOnly],
["TwUiSlider", LazyTwUiSlider],
["TwUiSpinner", LazyTwUiSpinner],
["TwUiTabBar", LazyTwUiTabBar],
["TwUiToast", LazyTwUiToast],
["TwUiTooltip", LazyTwUiTooltip],
["TwUiTopBar", LazyTwUiTopBar],
["TwUiTradeVariants", LazyTwUiTradeVariants],
["TwUiUserInfo", LazyTwUiUserInfo],
["TwUserAvatar", LazyTwUserAvatar],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
